import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";

export const OrganizationGridButtons = ({
  createPath,
  canCreate,
  canDownload,
  canArchive,
  excelExport,
  selectedIds,
  fetchEndpoint,
  type,
}) => {
  const history = useHistory();
  const displayType = type === "SubDepartment" ? "Sub-Department" : type;

  return (
    <div className="organization-tab-buttons">
      <div className="fluent-button-container">
        <FluentButton
          className="organization-tab-button-container"
          appearance="primary"
          onClick={() => history.push(createPath)}
          disabled={!canCreate}
          text={`Create New ${displayType}`}
        />
      </div>
      <div className="fluent-button-container">
        <FluentButton
          onClick={excelExport}
          disabled={!canDownload}
          text={`Download ${displayType}`}
        />
      </div>
      <div className="fluent-button-container">
        <FluentButton
          icon={<FluentUiIcon name={"ArchiveRegular"} size={18} disabled={!canArchive}/>}
          onClick={() => {
            if (selectedIds?.length > 0) {
              fetchEndpoint({ DeletedIdsSelected: selectedIds }, type);
            }
          }}
          disabled={!canArchive}
          text={"Archive"}
        />
      </div>
    </div>
  );
};

OrganizationGridButtons.propTypes = {
  createPath: PropTypes.string.isRequired,
  canCreate: PropTypes.bool.isRequired,
  canDownload: PropTypes.bool.isRequired,
  canArchive: PropTypes.bool.isRequired,
  excelExport: PropTypes.func.isRequired,
  selectedIds: PropTypes.array,
  fetchEndpoint: PropTypes.func,
  type: PropTypes.string.isRequired,
};
